export default "__VITE_ASSET__d740a83f__"